export const ROUTE = {
    SUBSCRIPTIONS:{
        MAIN:'/subscriptions',
        HOME:'/subscriptions/home',
        BUY:'/subscriptions/buy',
        FREE_TIME:'/subscriptions/free-time',
        SUBSCRIPTIONS:'/subscriptions/subscriptions',
        PERMITS:'/subscriptions/permits',
        SUBSCRIPTION_OFFERS:'/subscriptions/subscription-offers',
    },
    MY_PARKING_LOT:{
        MAIN:'/my-parking-lot',
        PARKING_LOT:'/my-parking-lot/parking-lot',
        PAYMENTS:'/my-parking-lot/payments',
        ANALYTICS:'/my-parking-lot/analytics',
        CUSTOMER_NOTIFICATION_EXCLUSIONS:'/my-parking-lot/customer-notification-exclusions',
    },
    RESERVATIONS:{
        MAIN:'/reservations',
        MY_RESERVATIONS:'/reservations/my-reservations',
        RESERVATIONS:'/reservations/reservations',
        RESERVATION_OFFERS:'/reservations/reservation-offers',
    }
}
